import { atom } from "recoil";
import {
  PaymentType,
  ProductType,
  RequestServiceType,
  TableOrderType,
  TableStateType,
} from "../assets/Type";

export const tableState = atom<TableStateType>({
  key: "tableState",
  default: {
    adult: 0,
    child: 0,
  },
});
// 인원 세팅 내역

export const isAdminMode = atom<boolean>({
  key: "isAdminMode",
  default: false,
});
// 관리자 창 상태

export const isTooltipView = atom<boolean>({
  key: "isTooltipView",
  default: false,
});
// 주문창 툴팁

export const orderWindowState = atom<boolean>({
  key: "orderWindowState",
  default: false,
});
// 주문창 상태

export const templateState = atom<number>({
  key: "templateState",
  default: 1,
});
// templateState : 0=세로 이미지(Default) / 1=가로 메뉴설명

export const customPayType = atom<boolean>({
  key: "customPayType",
  default: true,
});
// customPayType : true=선결제(Default) / false=후불

export const isOrderState = atom<boolean>({
  key: "isOrderState",
  default: false,
});
// 주문확인창 상태

export const isRobot = atom<boolean>({
  key: "isRobot",
  default: false,
});
// 로봇 팝업 상태

export const requestState = atom<RequestServiceType[] | null>({
  key: "requestState",
  default: [],
});
// 서비스 요청 내역

export const cartState = atom<ProductType[] | null>({
  key: "cartState",
  default: [],
});
// 장바구니 내역

export const paymentData = atom<PaymentType>({
  key: "paymentData",
  default: {
    payType: "",
    totalAmount: 0,
    payAmount: 0,
    usePoint: 0,
    rewardPoint: 0,
    nPay: null,
  },
});
// 결제 관련 정보

export const orderState = atom<TableOrderType | null>({
  key: "orderState",
  default: {
    table: {
      tableNum: 1,
      tableType: "창가",
      tableFloor: 1,
    },
    person: { adult: 2, child: 0 },
    orderData: [],
  },
});
// 주문 내역
